module.exports = __webpack_public_path__ + "img/illust-oba-close.937ff973.png";